import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
    const [isPulsing, setIsPulsing] = useState(false);
    const whatsappNumber = '+919970657588';
    const message = 'Hello, I would like to know more about R.K. English High School.';
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

    useEffect(() => {
        const interval = setInterval(() => {
            setIsPulsing(true);
            setTimeout(() => setIsPulsing(false), 2000);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`fixed bottom-6 right-6 z-40 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all transform hover:scale-110 ${isPulsing ? 'animate-pulse-glow' : ''}`}
            data-testid="whatsapp-button"
            aria-label="Chat on WhatsApp"
        >
            <MessageCircle className="w-7 h-7" />
        </a>
    );
};

export default WhatsAppButton;